import React from 'react'

export default function ProductCard(props) {
    return (
        <>
            <div>
                <img src={props.image} className='w-full' alt="product_img" />
                <div className='pl-2 sm:pl-3 md:pl-5'>
                    <p className='mt-1 text-[12px] sm:text-[16px] font-bold text-gray-500'>{props.category}</p>
                    <h6 className='text-[16px] sm:text-xl  text-gray-900'>{props.name}</h6>
                </div>
            </div>
        </>
    )
}
